import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "semantic-ui-react";
import { Link } from "react-router-dom";

/**
 * LoginPrompt: () => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Login message displayed when the user is not logged in,
 * allowing the user to login
 */
const LoginPrompt = () => (
  <div>
    <h2>
      <FormattedMessage
        id="welcome.loggedout.prompt.title"
        description="Title for login prompt if user is not logged in"
      />
    </h2>
    <p>
      <FormattedMessage
        id="welcome.loggedout.prompt.description"
        description="Description for login prompt if user is not logged in"
      />
    </p>
    <Link to="/login">
      <Button primary>
        <FormattedMessage id="login.submit" />
      </Button>
    </Link>
  </div>
);

export default LoginPrompt;



// WEBPACK FOOTER //
// ./src/components/loginprompt/LoginPrompt.js